/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://rxoocsywjvdivmbeg3jyptbgry.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-ezrbfp3v6vh35b6hc4wum6nhku",
    "aws_cognito_identity_pool_id": "eu-west-2:aba467cd-6c6f-4e5f-b2e8-8ee2ad30f2ee",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_gaJLSPzfF",
    "aws_user_pools_web_client_id": "1bb2ha9gpd6q0q4jqfreed5p53",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
